import React, { Fragment, useRef } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination, Checkbox} from '@mui/material';
import TextField from '@mui/material/TextField';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import ConsumableMasterEdit from './ConsumMasterEdit';
import ConsumableMasterRead from './ConsumMasterRead';
import { useEffect } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import {useGetconsumcatQuery} from '../../../features/consumcat/consumcatApiSlice'
import {useAddNewconsummasterMutation, useDeleteconsummasterMutation, useGetconsummasterQuery, useUpdateconsummasterMutation} from '../../../features/consummaster/consummasterApiSlice'
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import {TableContStyle, TableHeadStyle } from '../../../Styles/TableStyles';
import ExcelDownload from '../../../data/exceldownload';
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`
const FormEleWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items:center;
`
const Button2Div =styled.div`
  display: flex;
  justify-content: end;
`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`
const SubmitButton = styled(CommonButton)`
height:"40px";
margin-top:"0px";
margin-bottom:"0px";
`

const ComplaintCategoryWrapper =styled.div`
  display: flex;
  align-items: center;
  justify-content:space-between;
`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const tableFontSize = 18;


export default function ConsumMaster () {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const {consummaster} = useGetconsummasterQuery("consummaster", {
    selectFromResult: ({data}) => ({
      consummaster: data?.entities
    }),
  })
  const {consumcat} = useGetconsumcatQuery("consumcat", {
    selectFromResult: ({data}) => ({
      consumcat: data?.entities
    }),
  })
  const {assetmaster} = useGetAssetMastersQuery("assetmaster", {
    selectFromResult: ({data}) => ({
      assetmaster: data?.entities
    }), 
  })
  const [addNewConsumMaster] = useAddNewconsummasterMutation();
  const [updateConsMaster] = useUpdateconsummasterMutation();
  const [deleteConsMaster] = useDeleteconsummasterMutation();

  const [tabledata, setTabledata]= useState([]);
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({
    id:"",
    consumable:"",
    consumcategory:"",
    asset:[]   
  });
  const [addConsumMasterData, setAddConsumMasterData] = useState({
    consumable:"",
    consumcategory:"",
    asset:[]
  });
  const [downloadData, setDownloadData] = useState({});
  const [sentData, setSentData ]= useState(0);

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmit = async (event) =>{
    event.preventDefault();
    if(!addConsumMasterData?.consumable?.length){
      alert(`Please enter value for Consumable`)
      return;
    }
    if(!addConsumMasterData?.consumcategory?.length){
      alert(`Please select value for Consumable Category`)
      return;
    }
    if(!addConsumMasterData?.asset?.length){
      alert("Please select value for Applicable Asset");
      return
    }
    try{
      let bodyobject = {...addConsumMasterData}
      const foundConsumMaster = consummaster? Object.values(consummaster).some(el => el.consumable === addConsumMasterData.consumable):false;

      // {"name":addConsumCatData.name.trim()};
      if(foundConsumMaster) return alert(`Consumable "${addConsumMasterData?.consumable}" already exists`)
      if(!foundConsumMaster && addConsumMasterData?.consumable?.length ){
          const res = await addNewConsumMaster(bodyobject) ;
          alert(`New Consumable ${bodyobject.consumable} added in masters.`)
          setAddConsumMasterData({});
          }
    } catch(err){console.log(err)}
    setAddConsumMasterData({})    
  }

  const onClickEdit = (e, k, row)=>{
    let tempEditFormData = {...editFormData};
    tempEditFormData.id = row?.id;
    tempEditFormData.consumable = consummaster[row.id]?.consumable;
    tempEditFormData.consumcategory = consummaster[row.id]?.consumcategory;
    tempEditFormData.asset = consummaster[row.id]?.asset;
    setEditFormData(tempEditFormData);
    setEditCategory(k+1);
  }

  const onChangeAddConsumMaster = (event, newvalue, name) =>{
    let temp ={...addConsumMasterData}
    if(event.target.name){
      temp = {...temp, [event.target.name]:event.target.value}
    }
    if(name){
      temp = {...temp, [name]:newvalue}
    }
    if(name === "consumcategory"){
      temp.asset="";
    }
    if(name === "asset" && newvalue.includes("Not Applicable")){
      temp["asset"] = ["Not Applicable"]
    }
    setAddConsumMasterData(temp);
  }

  const onChangeEditConsumMaster = (event, newValue, name) =>{
    let tempEditFormData = {...editFormData};
    if(event.target.name){
      tempEditFormData = {...tempEditFormData, [event.target.name]:event.target.value}
    }
    if(name){
      tempEditFormData = {...tempEditFormData, [name]:newValue}
    }
    if(name === "consumcategory"){
      tempEditFormData.asset = "";
    }
    if(name === "asset" && newValue.includes("Not Applicable")){
      tempEditFormData["asset"] = ["Not Applicable"]
    }
    setEditFormData(tempEditFormData);
  }

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    if(!editFormData.consumable.length || !editFormData.consumcategory.length || !editFormData.asset.length){
      return alert("Please Enter valid values before submitting");
    }
    if(Object.values(consummaster).filter(a => a._id !== editFormData.id).map(x => x.consumable).includes(editFormData.consumable)){
      return alert("Consumable Category already exists in the database.")
    }
    try{
    setEditCategory(null);
    const response = await updateConsMaster(editFormData)
    }catch(err){}
  }  

  const handleCancelClick = (e,k) => {   
    let tempEditFormData = {...editFormData};
    tempEditFormData.id = "";
    tempEditFormData.name = "";
    setEditFormData(tempEditFormData);
    setEditCategory(null);
  };

  const handleDeleteClick = async (e,k,row) => {
    e.preventDefault();
    let body = {"id":row.id}
    const response = window.confirm(`Do you want to delete Consumable Id "${row.name}"` )
    if(!response) return;
    alert(`Consumable "${row.name}" deleted successfully`);
    const result = await deleteConsMaster(body);
  };  

  useEffect(()=>{
    if(consummaster){
      const consummasterArray = Object.values(consummaster);
      setTabledata(consummasterArray);     
    }
  },[consummaster])


//Setting the download data for excel download.
useEffect(()=>{
  let finalDownloadData = [];
  let finalSortedDownloadData = [];
  const keyOrderArray = ["consumable", "consumcategory", "asset"]
  let tempDownloadData = structuredClone(tabledata);
  for(let val of tempDownloadData ){
      let {_id, ...others} = val;
      others = {...others, ["consumable"]: val.consumable, ["consumcategory"]:val.consumcategory, ["asset"]:val.asset }
      finalDownloadData.push(others)
    }
    for(let value of finalDownloadData){
        let tempObject = {}
        for(let val of keyOrderArray){
            tempObject = {...tempObject, [val]:value[val]};
        }
        finalSortedDownloadData.push(tempObject);
    }
    setDownloadData(finalSortedDownloadData)
}, [tabledata])
 
   
  return (
    <>
   
    <Displaydiv1>
      <HeadingWrap>
        <Span>Add New Consumable Master</Span>
      </HeadingWrap>

    <ComplaintCategoryWrapper>
      <Addcategform onSubmit={onSubmit}>
        <FormEleWrapper>
          <TextField
            id="outlined-basic"
            size='small'
            name='consumable'
            onChange={(event, newValue) => onChangeAddConsumMaster(event, newValue)}
            label="Enter a New Consumable"
            value={addConsumMasterData?.consumable || ""}
            variant="outlined"
            sx={{backgroundColor:"white", width:"220px", height:"40px"}}
          />
          <Autocomplete
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disablePortal
            id="combo-box-demo"
            size='small'
            value={addConsumMasterData.consumcategory || "" }
            onChange={(event, newValue) => onChangeAddConsumMaster(event, newValue, "consumcategory")}
            options={consumcat? Object.values(consumcat)?.map(x => x?.name): []}
            sx={{backgroundColor:"white", width:"230px", marginLeft:"20px", marginRight:"20px",height:"40px"}}
            renderInput={(params) => <TextField {...params} label={"Select Consumable Category"} />}
         />

          <Autocomplete
            multiple
            id="checkboxes-tags-demo"
            onChange={(event, newValue) => onChangeAddConsumMaster(event, newValue, "asset")}
            size="small"
            value={addConsumMasterData.asset || [] }
            options={assetmaster? !addConsumMasterData?.asset?.includes("Not Applicable")? ["Not Applicable"].concat(Object.values(assetmaster).map(x => x.Asset.map(y => y.Name)).flat(3)):["Not Applicable"]:[]}
            disableCloseOnSelect
            getOptionLabel={(option) => option}
            renderOption={(props, option, { selected }) => (
              <li {...props} style={{ fontSize: '2 rem' }}>
                <Checkbox
                  icon={icon}
                  checkedIcon={checkedIcon}
                  style={{ marginRight: 0, marginLeft:-8 }}
                  checked={selected}
                />
                {option}
              </li>
            )}
            sx={{ width: 250}}
            renderInput={(params) => (
              <TextField {...params} label="Applicable Assets" sx={{background:"white", width:"100%"}} />
            )}
          />
        <SubmitButton type='submit'>Submit</SubmitButton>
        </FormEleWrapper>        
      </Addcategform>
      <Button2Div>
          <ExcelDownload data={downloadData} filename={"consumablecat"} sheetName={"sheet1"}/>
        </Button2Div> 
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper} sx={{ backgroundColor: TableContStyle.backgroundColor }}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow sx={{ backgroundColor: TableHeadStyle.backgroundColor}}>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"12%"}}}align="left">Sl.No.</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"30%"}}} align="left">Consumable</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"18%"}}} align="left">Category</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Applicable Assets</TableCell>
          <TableCell style={{ fontSize: TableHeadStyle.fontSize, fontWeight: TableHeadStyle.fontWeight }} sx={{width:{md:"20%"}}} align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <ConsumableMasterEdit row={row} k={key} editFormData={editFormData} handleCancelClick={handleCancelClick} page={page} consumcat={consumcat}
                rowsPerPage={rowsPerPage} editCategory={editCategory} onChangeEditConsumMaster={onChangeEditConsumMaster} SubmitButton ={SubmitButton} assetmaster={assetmaster} 
               />

                :<ConsumableMasterRead row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} page={page} rowsPerPage={rowsPerPage} tableFontSize={tableFontSize} SubmitButton ={SubmitButton}              
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>    
    </Displaydiv1>
    </>
  );
}